import script from "./ImportWaiting.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportWaiting.vue?vue&type=script&setup=true&lang=ts"

import "./ImportWaiting.vue?vue&type=style&index=0&id=712fe286&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712fe286"]])

export default __exports__